<div class="d-flex justify-content-center flex-wrap">
  <div *ngFor="let benefit of benefitsClaimed">
    <fgb-benefit-claimed class="cursor-pointer" [benefit]="benefit" (click)="openModal(benefit)"></fgb-benefit-claimed>
  </div>
  <div class="m-3" *ngFor="let unclaimedBenefit of unclaimedBenefits">
    <div class="unclaimed icon icon-plus text-secondary"></div>
  </div>
</div>
